/* unplugin-vue-components disabled */import script from "./ContractSettlement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractSettlement.vue?vue&type=script&setup=true&lang=js"

import "./ContractSettlement.vue?vue&type=style&index=0&id=5710179a&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5710179a"]])

export default __exports__